/**
 * whether the param is `undefined`
 * @param {*} obj
 * @return {Boolean}
 */
export var isUndefined = function (obj) { return typeof obj === 'undefined'; };
/**
 * whether the param is an object
 * @param {*} obj
 * @return {Boolean}
 */
export var isObject = function (obj) { return typeof obj === 'object'; };
//# sourceMappingURL=tools.js.map